import Client from "@/repositories/Clients/AxiosClient";
import Config from "@/repositories/Clients/AxiosDefaultConfig";

const resource = `${Config.basePath}/integration`;

export default {
  show() {
    return Client.get(`${resource}`);
  },
  sendInstruction(payload) {
    return Client.post(`${resource}/send`, payload);
  },
  sendWebViewInstruction(payload) {
    return Client.post(`${resource}/sendWebView`, payload);
  },
  update(payload) {
    return Client.put(`${resource}`, payload);
  },
  updateConfigPartner(payload) {
    return Client.put(`${resource}/partner/config`, payload);
  },
  showChatMe() {
    return Client.get(`${resource}/chatme`);
  },
  updateChatMe(payload) {
    return Client.put(`${resource}/chatme`, payload);
  },
  toggleChatMeEligibility() {
    return Client.put(`${resource}/chatme/eligibility`);
  },
  generateChatMeConfig(payload) {
    return Client.post(`${resource}/chatme/generate`, payload);
  },
};
